import { WalkMeState } from '@core/walk-me/store/states/walk-me.state';

export const walkMeState = [WalkMeState];
